import log from 'salvo-lite/log'
import Choices from 'choices.js'

// eslint-disable-next-line no-unused-vars
const currencyChoices = new Choices('.CurrencySelector__Select', {
    searchEnabled: false,
    itemSelectText: ''
})

class Currencies {
    constructor (theme, elem) {
        this._elem = elem
        this._flag = document.querySelector('.currency-selector--flag')
        this._currencySymbol = document.querySelector('.currency-selector--currency-symbol')

        this._vars = {
            currentCurrency: window.theme.shopCurrency,
            initialCurrency: window.Currency.cookie.read(),
            selector: '.money',
            format: 'money_with_currency_format',
            initialised: false
        }
    }

    onInit () {
        log.debug(this.constructor.name, 'Initialising...', this)

        if (!this._vars.initialCurrency) this._vars.initialCurrency = this._vars.currentCurrency

        this._convertPrices(this._vars.currentCurrency, this._vars.initialCurrency, this._vars.selector, this._vars.format)
        this._changeFlagsAndSymbols(this._vars.currentCurrency)

        this._elem.addEventListener('change', () => {
            this._convertPrices(this._vars.currentCurrency, this._elem.options[this._elem.selectedIndex].value, this._vars.selector, this._vars.format)
            this._changeFlagsAndSymbols(this._vars.currentCurrency)
        })
    }

    _convertPrices (a, b, c, d) {
        window.Currency.convertAll(a, b, c, d)
        window.Currency.cookie.write()

        if (!this._vars.initialised) {
            this._vars.currentCurrency = this._vars.initialCurrency
            this._vars.initialised = true
        } else {
            this._vars.currentCurrency = window.Currency.cookie.read()
        }
    }

    _changeFlagsAndSymbols (c) {
        if (c) {
            let currency = c.toLowerCase()
            this._flag.classList.forEach((_class) => {
                if (_class.includes('flag-')) {
                    this._flag.classList.remove(_class)
                    this._flag.classList.add(`flag-${currency}`)
                }
            })
            this._currencySymbol.classList.forEach((_class) => {
                if (_class.includes('currency-symbol-')) {
                    this._currencySymbol.classList.remove(_class)
                    this._currencySymbol.classList.add(`currency-symbol-${currency}`)
                }
            })
        }
    }
}

export default Currencies



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Currencies.js